import { takeLatest, takeLeading } from "redux-saga/effects";

import { actionTypes } from "../actions";
import { fetchLocations } from "./fetchLocationAutocompleteSaga";
import { fetchTripDestinationsSaga } from "./fetchTripDestinationsSaga";
import { fetchCombinedAutocompleteSaga } from "./fetchCombinedAutocompleteSaga";

export function* watchFetchLocationCategories() {
  yield takeLatest(actionTypes.FETCH_LOCATION_CATEGORIES, fetchLocations);
}

export function* watchFetchTripDestinations() {
  yield takeLeading(actionTypes.FETCH_TRIP_DESTINATIONS, fetchTripDestinationsSaga);
}

export function* watchFetchCombinedAutocomplete() {
  yield takeLatest(
    actionTypes.FETCH_COMBINED_AUTOCOMPLETE,
    fetchCombinedAutocompleteSaga
  );
}
